'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _DoubleRightOutlined = _interopRequireDefault(require('./lib/icons/DoubleRightOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _DoubleRightOutlined;
exports.default = _default;
module.exports = _default;